
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pro/author/[...slug]",
      function () {
        return require("private-next-pages/pro/author/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pro/author/[...slug]"])
      });
    }
  